import { PermanentJobsApi } from '../clients';

/**
 * Shortlist a candidate
 *
 * @param {import('../types/ShortlistCandidate.parameters').IShortlistCandidatePayload} payload - Request payload
 * @returns {Promise<void>} No content response
 */
export const shortlistCandidate = async ({ candidateId }) => {
  await PermanentJobsApi.shortlistCandidate({ candidateId });
};
